import { useI18n } from 'vue-i18n'

type Lang = 'ru' | 'ky'

const UNITS: Record<Lang, { thousand: string; million: string }> = {
  ru: {
    thousand: 'тыс',
    million: 'млн'
  },
  ky: {
    thousand: 'миң',
    million: 'млн'
  }
}

export const useHumanNumber = () => {
  const { locale } = useI18n()

  const formatHumanNumber = (value?: number | null) => {
    if (value === null || value === undefined) return '—'

    const lang = (locale.value as Lang) || 'ru'
    const units = UNITS[lang]
    const abs = Math.abs(value)

    if (abs >= 1_000_000) {
      const v = value / 1_000_000
      return `${Number.isInteger(v) ? v : v.toFixed(1)} ${units.million}`
    }

    if (abs >= 10_000) {
      const v = value / 1_000
      return `${Number.isInteger(v) ? v : Math.round(v)} ${units.thousand}`
    }

    return new Intl.NumberFormat(lang === 'ky' ? 'ky-KG' : 'ru-RU').format(value)
  }

  return {
    formatHumanNumber
  }
}
